import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {styles} from "./SummaryImageStyles";
const useStyles = makeStyles(styles);

const KegCycleImage = () => {
    const classes = useStyles();

    return (
        <Fragment>
            <div style={{textAlign: 'center'}}>
                <img src={require('../../../assets/images/KegCycles.svg')} alt={'alt'} style={{width: '26px'}} className={classes.image} />
            </div>
        </Fragment>
    )
}

export default KegCycleImage;
